import { Button as MantineButton, createPolymorphicComponent } from '@mantine/core';
import { forwardRef } from 'react';
import { AppButtonProps } from 'theme/components/Buttons/Button/types';

/**
 * Typed application button wrapper with variant and size autocomplete limited
 * to values supported by the project theme.
 */
const ButtonBase = forwardRef<HTMLButtonElement, AppButtonProps>(function Button(props, ref) {
  return <MantineButton ref={ref} {...props} />;
});

const Button = createPolymorphicComponent<'button', AppButtonProps>(ButtonBase);

export default Button;

export type { AppButtonProps as ButtonProps } from 'theme/components/Buttons/Button/types';
export { APP_BUTTON_SIZES, APP_BUTTON_VARIANTS } from 'theme/components/Buttons/Button/types';
export type { AppButtonSize, AppButtonVariant } from 'theme/components/Buttons/Button/types';
